import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Row } from "reactstrap";
import { PackRequestProvider } from "features/forms/context/PackContexts";
import {
	useFromPartnerLink,
	useFromPartnerSend,
} from "stores/LocalStorageHelper";
import UAC from "services/uacService/UAC";
import { credit700Lenders } from "constants/Constants";
import CudlLogo from "assets/img/cudl-logo.png";
import AppOneLogo from "assets/img/appone-logo.png";
import DealerTrackLogo from "assets/img/dealertrack-logo.png";
import Credit700 from "services/credit700Service/Credit700";
import RouteOne from "services/routeOneService/RouteOne";
import LenderPacket from "components/lenderPacket/LenderPacket";
import LoansTable from "features/loanManager/compontents/LoansTable";
import { getSubmittedAppsByDealer } from "api/AppTrackerAPI";
import useCurrentDealStore from "stores/DealStore";
import shallow from "zustand/shallow";
import AppTracker from "services/appTrackerService/appTracker";
import { useFromUser } from "stores/LocalStorageHelper";

/**
 * Component displaying integrations with various lenders.
 * @component
 * @returns {JSX.Element} The rendered component.
 */
const LenderIntegrations = () => {
	// Local state to hold fetched loans data
	const [loansData, setLoansData] = useState([]);
	const dealerID = useFromUser("dealerID");
	const locationID = useFromUser("locationID");
	console.log("dealerID:", dealerID);
	console.log("locationID:", locationID);
	const compositeId = `${dealerID ?? ""}${locationID ?? ""}`;

	console.log("compositeId:", compositeId);

	// Retrieve necessary data from local storage helpers
	const isCreditSignup = useFromPartnerLink("isCreditSignup");

	// Deal store
	const { ID: currentDealId } = useCurrentDealStore(
		// Renamed ID to currentDealId for clarity
		(state) => ({
			ID: state.deal.ID,
		}),
		shallow
	);
	console.log("ID:", currentDealId);

	const useUACC = useFromPartnerSend("useUACC");

	// Inside LenderIntegrations
	const fetchLoans = () => {
		if (!dealerID || !locationID) return;

		getSubmittedAppsByDealer(compositeId)
			.then((data) => {
				console.log("Fetched apps:", data);
				setLoansData(data);
			})
			.catch((err) => {
				console.error(
					`[LenderIntegrations] failed to fetch loans for ID ${compositeId}:`,
					err
				);
				setLoansData([]);
			});
	};

	// Use useEffect to load initially
	useEffect(() => {
		fetchLoans();
	}, [dealerID, locationID, compositeId]);

	// Filter the loansData to only include apps for the current deal
	const filteredLoansData = Array.isArray(loansData)
		? loansData.filter((loan) => loan.deal_id === currentDealId)
		: [];
	return (
		<>
			<Row className="mt-3 justify-content-center" style={{ gap: "12px" }}>
				<div style={{ width: "300px" }} className="text-center">
					<PackRequestProvider>
						<LenderPacket />
					</PackRequestProvider>
				</div>
				<div style={{ width: "300px" }} className="text-center">
					<AppTracker onAppSubmit={fetchLoans} />
				</div>
				{useUACC === 1 && (
					<div style={{ width: "300px" }} className="text-center">
						<UAC />
					</div>
				)}
				<div style={{ width: "300px" }} className="text-center">
					<RouteOne />
				</div>
				{[
					{ los: credit700Lenders.cudl, logo: CudlLogo },
					{ los: credit700Lenders.appOne, logo: AppOneLogo },
					{ los: credit700Lenders.dealerTrack, logo: DealerTrackLogo },
					// { los: credit700Lenders.dealerClick, logo: DealerClickLogo },
				].map((lender, index) => (
					<div style={{ width: "300px" }} key={index} className="text-center">
						<Credit700
							los={lender.los}
							logo={lender.logo}
							has700={isCreditSignup}
							isDealerClick={lender.los === credit700Lenders.dealerClick}
						/>
					</div>
				))}
			</Row>
			<hr className="my-4 w-75 mx-auto" />
			<LoansTable data={filteredLoansData} hideViewDealButton />{" "}
			{/* Pass the filtered data */}
		</>
	);
};

LenderIntegrations.propTypes = {
	isCreditSignup: PropTypes.bool,
	useUACC: PropTypes.number,
};

export default LenderIntegrations;
